import { render, staticRenderFns } from "./Component_PdfInfo.vue?vue&type=template&id=56b653cc&"
import script from "./Component_PdfInfo.vue?vue&type=script&lang=js&"
export * from "./Component_PdfInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports